import { ChevronRight } from '@/assets/icons'
import { MenuItem } from '@/components/menu/MenuItem'
import type { ExternalStorageMenuStatus } from '@/user_files/external-storage/hooks/useExternalStorageMenuStatus'

type ExternalStorageMenuItemsProps = {
  status: ExternalStorageMenuStatus
  onOpenExternalFiles: () => void
  onConnectFolder: () => void
  openExternalFilesLabel?: string
}

export function ExternalStorageMenuItems({ status, onOpenExternalFiles, onConnectFolder, openExternalFilesLabel }: ExternalStorageMenuItemsProps) {
  if (!status.showMenuItem || !status.connectedProviderMeta || !status.ConnectedProviderIcon) {
    return null
  }

  if (status.actionKind === 'open-files') {
    return (
      <MenuItem
        label={openExternalFilesLabel ?? `Add from ${status.connectedProviderMeta.label}`}
        icon={status.ConnectedProviderIcon}
        variant="neutral"
        onSelect={onOpenExternalFiles}
      />
    )
  }

  return (
    <MenuItem
      label={`Connect a ${status.connectedProviderMeta.label} folder to this matter`}
      icon={status.ConnectedProviderIcon}
      variant="neutral"
      subheading="Attach synced files anywhere in this matter"
      trailingIcon={ChevronRight}
      onSelect={onConnectFolder}
    />
  )
}
